module.exports = __webpack_public_path__ + "static/media/consulting_about_13.1f8522d8.webp";